/**
 * /frontend/src/features/analytics/components/appointments/AppointmentKPIs.js
 */

import React from 'react';
import KPICardRow from '../shared/KPICardRow';
import KPICard from '../shared/KPICard';
import { formatDays, formatPercent } from '../../utils/formatters';

/**
 * Appointment KPI cards.
 * @param {{summary:any}} props
 * @returns {JSX.Element}
 */
const AppointmentKPIs = ({ summary }) => (
  <KPICardRow>
    <KPICard label="Booked" value={Number(summary?.totalBooked || 0).toLocaleString('en-IN')} />
    <KPICard label="Completed" value={Number(summary?.totalCompleted || 0).toLocaleString('en-IN')} />
    <KPICard label="No-show rate" value={formatPercent(summary?.noShowRate)} />
    <KPICard label="Cancellation rate" value={formatPercent(summary?.cancellationRate)} />
    <KPICard label="Avg lead time" value={formatDays(summary?.avgLeadTimeDays)} />
    <KPICard label="Utilization" value={formatPercent(summary?.utilizationRate)} />
  </KPICardRow>
);

export default AppointmentKPIs;

